import * as Rx from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import type { User } from 'v2/interfaces/user';
import type { WarningAlert } from 'v2/interfaces/warning';

import apiService from './api';
import cacheService from './cache';
import eduzzAccountsService from './eduzzAccount';

import type { EduzzAccountsService } from './eduzzAccount';
import type { Observable } from 'rxjs';

/**
 * Service responsible for controlling `Warning` component.
 *
 * @class WarningsService
 */
class WarningsService {
  /**
   * @method loadGlobalWarnings
   * @return {Observable} an array of `WarningAlert` with the enabled warning alerts
   * returned by the API
   */

  private warnings$ = new Rx.BehaviorSubject<WarningAlert[]>(null);
  private currentUser: User;

  constructor(private eduzzAccountsService: EduzzAccountsService) {
    this.eduzzAccountsService.getUser().subscribe((user) => {
      this.currentUser = user;
    });
  }

  public getWarnings = (): Observable<WarningAlert[]> => {
    const cacheKey = `alerts-${this.currentUser.id}`;

    return cacheService.getData(cacheKey).pipe(
      switchMap((cache) => {
        if (!cache || cacheService.isExpirated(cache)) {
          return apiService.get('/alerts/self').pipe(
            map((response) => response.data),
            switchMap((alerts) => cacheService.saveData(cacheKey, alerts, { persist: true, expirationMinutes: 15 })),
            map((cache) => cache.data)
          );
        }
        return Rx.of(cache.data);
      })
    );
  };
}

const WarningsServiceFactory = new WarningsService(eduzzAccountsService);
export const warningsFactory = WarningsServiceFactory;
